import React, { Component } from 'react';
import Menu from '../components/menu.js'
import _ from 'lodash';
import { db,auth } from '../firebase';
import axios from 'axios';

export default class AppMenu extends Component {


    constructor() {
        super();
        this.state = {

            positions: [],
            position_symbols: [],
            recent_symbols: []
        }

    }

    async componentDidMount() {

        let items = await db.getOpenPositions();
        items = items.map(a => {

            a.unrealized_gains = 0;
            return a;
        });
        this.getLastestPrices(items);
        this.setState({
            positions: items
        });

        // const itemsRef = firebase.database().ref('users/positions').orderByChild("quantity").startAt(1);
        // itemsRef.on('value', (snapshot) => {

        //     let items = _.values(snapshot.val()).map(a => {

        //         a.unrealized_gains = 0;
        //         return a;
        //     });
        //     this.getLastestPrices(items);
        //     this.setState({
        //         positions: items
        //     });
        // });
    }

    async componentWillReceiveProps(nextProps) {

        if (this.props.selected_menu != nextProps.selected_menu) {


            let current_symbol = nextProps.selected_menu.indexOf("symbol/") > 0 ? nextProps.selected_menu.split("/")[2] : null;
            if (current_symbol != null && this.state.position_symbols.indexOf(current_symbol) < 0) {

                let recent_symbols = this.state.recent_symbols;
                if (recent_symbols.indexOf(current_symbol) < 0) {

                    recent_symbols = [current_symbol, ...recent_symbols];
                    this.setState({

                        recent_symbols: recent_symbols
                    });
                }
            }
        }
    }




    async  getLastestPrices(items) {

        let prices = await axios.get('https://api.iextrading.com/1.0/stock/market/batch?types=price&symbols=' + items.map(a => a.symbol).join(","));
        if (prices && prices.data) {

            this.setState({

                position_symbols: this.state.positions.map(a => { return a.symbol }),
                positions: this.state.positions.map(a => {

                    a.last_price = prices.data[a.symbol] ? prices.data[a.symbol].price : 0;
                    a.unrealized_gains = a.last_price > 0 ? ((a.last_price - a.price) * a.quantity) : a.quantity * a.price * -1;
                    return a;
                })
            })
        }
    }

    render() {


        let menu_items = [
            { icon: 'fa fa-home', name: 'Home', link: '/' },
            { icon: 'fa fa-th-large', name: 'Positions', link: '/Positions' },
            { icon: 'fa fa-history', name: 'History', link: '/History' },
            { icon: 'fa fa-list', name: 'Orders', link: '/Orders' },
            { icon: 'fa fa-money', name: 'Cash', link: '/Cash' },
            { icon: 'fa fa-industry', name: 'Sectors', link: '/sectors' },
            { icon: 'fa fa-fire', name: 'Trending', link: '/trending' },
            // { icon: 'fa fa-history', name: 'History', link: '/History' },
            // { icon: 'fa fa-exchange', name: 'Transactions', link: '/Transactions' },
            // { icon: 'fa fa-book', name: 'Research', link: '/Research' },
            { icon: 'fa fa-cog', name: 'Profile', link: '/Profile' }
        ]

        let tag_items = [];
        // tag_items = [
        //     { name: 'Income' },
        //     { name: 'Growth' },
        //     { name: 'LookingToScale' },
        //     { name: 'LookingToTrim' },
        //     { name: 'LookingToClose' }
        // ];

        //symbol_items = [{ symbol: "STWD", gain: 1 }, { symbol: "BAC", gain: 0 }, { symbol: "ATVI", gain: 1 }];



        return (
            <Menu
                onPageSelected={this.props.onPageSelected}
                symbol_items={this.state.positions}
                recent_items={this.state.recent_symbols}
                menu_items={menu_items}
                tag_items={tag_items}
                selected_menu={this.props.selected_menu} 
                onLogout={()=>auth.doSignOut()}/>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/app-menu.js